<template>
  <div v-if="isShowPage" class="login">
    <guide />
    <nav-bar :title="lang.login" class="nav-bars" :showType="'text'"></nav-bar>
    <section>
      <form action="javascript:" method="POST">
        <div class="login-wap">
          <div class="login-logo logo-wap">
            <img :src="`${pub.config.static}images/icon.png`" />
            <span>{{ lang.login }}</span>
          </div>
          <div class="logo-pc">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-logo" />
            </svg>
            <span>{{ lang.login }}</span>
          </div>
          <div class="group-login">
            <div class="login-error">{{ errorMsg }}</div>
            <span class="login-show-pwd" @click="showPwds">
              <svg class="icon" aria-hidden="true" slot="right" @click="showPop = false">
                <use :xlink:href="showPwd ? '#icon-hidpwd' : '#icon-showpwd'" />
              </svg>
            </span>
            <input type="text" :placeholder="lang.email" class="login-id" v-model="account" @input="errorMsg = ''" />

            <input :type="showPwd ? 'text' : 'password'" onkeyup="javascript:window._loginPass=true" :placeholder="lang.password" class="login-pwd" v-model="password" @input="errorMsg = ''" />

            <van-button size="large" :loading="loading" type="danger" @click="goLogin">{{ lang.login }}</van-button>
            <div class="login-find">
              <router-link to="/account/forget/">
                <span class="login-forget">{{ lang.forget }}</span> </router-link
              >|
              <router-link class="login-register" to="/register/">{{ lang.register }}</router-link>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
// import { Button, Icon, Field } from 'vant';
// import "vant/lib/button/style";
import pub from '../../common/public';
import lang from './../../common/language/login';
import guide from './../components/guide';
import navBar from './../components/navBar';
export default {
  name: 'login',
  data() {
    return {
      isShowPage: false,
      loading: false,
      lang: lang,
      showPwd: false,
      account: '',
      password: '',
      // verifyCode: "",
      errorMsg: '',
      showError: false,
      isfirstlogin: false,
      isPc: false
    };
  },
  mounted() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcUrl}zh-cn/help/memberlogin/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcUrl}en-us/help/memberlogin/`;
      } else {
        location.href = `${pub.config.pcUrl}help/memberlogin/`;
      }
    } else {
      this.isShowPage = true;
    }
    // console.log('hot');
    let _this = this;
    const userToken = this.pub.getCookie('cEVaUDFrZ1kd0RA');
    const hasLogin = sessionStorage.getItem('hasLogin');
    // if(userToken&&hasLogin){
    //   sessionStorage.removeItem("hasLogin");
    //   history.go(-1)
    // }

    setTimeout(() => {
      if (userToken) {
        this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
          if (res.data.code == 0 && res.data.result) this.pushUrl();
          else this.onLoginOut();
        });
      }
    }, 2000);
  },
  methods: {
    //退出登录
    onLoginOut() {
      this.axios.get(this.pub.getApi().LoginOut);
      this.pub.delCookie('ERnJaMWtkM');
      this.pub.delCookie('cEVaUDFrZ1kd0RA');
    },
    showPwds() {
      this.showPwd = !this.showPwd;
    },
    pushUrl() {
      const curLang = window._language === 'en-us' ? 'en-us/' : window._language === 'zh-hk' ? '' : 'zh-cn/';
      /**添加手册登录判断 */
      const isFirstLog = this.isfirstlogin ? '?isfirstlogin=true' : '';
      if (this.isfirstlogin) this.pub.setCookie('isfirstlogin', '1');
      let referrer = this.$route.query.referer || this.$route.query.referrer || '';
      referrer = referrer.replace('isfirstlogin', 'fst');
      referrer && referrer.indexOf('account') > -1 ? (referrer = null) : '';
      if (!referrer) document.body.clientWidth > 700 ? (location.href = this.pub.config.pcPassport + curLang + isFirstLog) : this.$router.push('/' + isFirstLog);
      else {
        if (document.referrer && referrer && document.referrer.indexOf('/login') == -1) {
          document.body.clientWidth > 700 ? (location.href = referrer + isFirstLog) : history.back(-1);
        } else if (this.$route.query.url) {
          location.href = referrer + `&url=${this.$route.query.url}&isfirstlogin=true`;
        } else {
          /**正常跳转 */
          //  console.log("跳转666："+ referrer + isFirstLog)
          location.href = referrer + isFirstLog;
        }
      }
      // referrer
      //  window.top.location.href = ;
      // : this.$router.push(
      //     this.$route.query.url ? this.$route.query.url : "/"
      //   );
    },
    goLogin() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 3000);
      // console.log('login')
      // this.axios.get("http://10.69.1.202:8001/User/GetUserInfo")
      if (!this.checkForm()) return;
      this.axios
        .post(
          this.pub.getApi().Login,
          {
            account: this.account,
            password: this.password
          }
          // {
          //   params: {
          //     "g-recaptcha": this.verifyCode
          //   }
          // }
        )
        .then(res => {
          this.loading = false;
          console.log(JSON.stringify(res.data));
          if (res.data.code === 0 && res.data.result) {
            // alert("是否第一次登录:"+res.data.result.isFirstLogin)
            /**记录是否是第一次登录 */
            this.isfirstlogin = res.data.result.isFirstLogin;
            const userinfo = JSON.stringify({
              userId: res.data.result.userID,
              nickName: res.data.result.nickName
            });
            // 设置登录用户id
            gio('setUserId', res.data.result.userID);
            // 登录成功埋点
            gio('track', 'login_success', {
              login_user_id: res.data.result.userID
            });
            this.pub.setCookie('ERnJaMWtkM', escape(userinfo), res.data.result.expirationTime); //写入用户编号
            this.pub.setCookie('cEVaUDFrZ1kd0RA', res.data.result.token, res.data.result.expirationTime);
            // console.log("写入");//写入token
            console.log(99, document.referrer);
            sessionStorage.setItem('hsasLogin', document.referrer);
            this.pushUrl();
          } else {
            if (res.data.code === 1324) {
              this.$router.push('/account/verify/?type=3&key=-1&email=' + this.account);
            } else {
              this.errorMsg = res.data.code === 400 || res.data.code === 1300 ? lang.error : lang.refuse;
              if (res.data.code === 1300) this.password = '';
              this.showError = true;
            }
          }
        })
        .catch(e => {
          this.loading = false;
          console.log('错误', e);
          this.errorMsg = this.lang.networkError;
          this.showError = true;
        });
    },
    checkForm() {
      /**去除掉邮箱头尾的空格 */
      this.account = this.account.trim();
      /**验证格式 */
      if (!this.account) {
        this.errorMsg = lang.emptyEmail;
        this.showError = true;
        return false;
      } else if (!/^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.account) || this.account.indexOf('__') > -1) {
        this.errorMsg = `${this.lang.emailReg}`;
        this.showError = true;
        return false;
      }
      if (!this.password) {
        this.errorMsg = lang.emptyPwd;
        this.showError = true;
        return false;
      }
      // if (!!!this.verifyCode) {
      //   this.errorMsg = lang.emptyCode;
      //   this.showError = true;
      //   return false;
      // }
      return true;
    }
  },
  components: {
    // [Button.name]: Button,
    // // [Icon.name]: Icon,
    // [Field.name]: Field,
    guide,
    navBar
  }
};
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  section {
    width: 100%;
  }
}

.login-wap {
  .login-error {
    width: 100%;
    text-align: center;
    color: #ea1b23;
    margin-bottom: 10px;
    position: absolute;
    top: 6px;
  }
  .g-recaptcha {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }

  width: 100%;
  padding-top: 10px;
  max-width: 470px;
  margin: auto;
  img {
    width: 40%;
  }
  .group-login {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: auto;
    padding-top: 35px;
    border-radius: 3px;
    overflow: hidden;
    input {
      height: 40px;
      padding: 5px 0 5px 20px;
      border: none;
      background: #f5f5f5;
    }

    .login-pwd {
      border-top: 1px solid #ececec;
    }

    .login-find {
      margin-top: 15px;
      color: #c9c9c9;
    }
    .login-forget {
      color: #c9c9c9;
      display: inline-block;
      margin-right: 10px;
    }
    .login-register {
      color: #3090ff;
      display: inline-block;
      margin-left: 10px;
    }
  }
}

.login-show-pwd {
  position: absolute;
  top: 99px;
  right: 18px;
  font-size: 20px;
}

.login-logo span,
.logo-pc {
  display: none;
}
@media screen and (min-width: 601px) {
  .guide {
    display: none;
  }
  .login {
    background-image: url('//static.house730.com/m/images/pcbg.jpg');
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-size: cover;
  }

  .logo-pc {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      font-size: 80px;
    }
    span {
      font-size: 30px;
      color: #ec404e;
      font-weight: 700;
    }
  }

  .logo-wap {
    display: none;
  }
  .login-wap {
    margin-top: 0px;
    border-radius: 20px;
    padding: 35px;
    width: 360px;
    background: rgba(255, 255, 255, 0.9);
  }
}
</style>
